/* eslint-disable sonarjs/no-duplicate-string */
import { ModalButtonType, ModalType, ModalButton } from '../../components/modals/modalAlert/types';
import { Modal } from '../../store/modals/modal/types';
// import { ModalButton } from '../../components/modals/modalAlert/types';
// import i18n from '../../i18n/helpers';
import { i18n } from 'ff-shared-components-core';

/*****
 *  Generic Modals
 *
 *****/

/**
 * Returns a modal with generic error message.
 * @param {string} textMessage - Message text body.
 * @param {string} okButtonText - Ok button title.
 * @returns {import('./types').Modal}
 */
export const BuildOkInfoModal = (textMessage: string, okButtonText: string): Modal => {
	return {
		type: ModalType.INFO,
		textMessage,
		okButton: { text: okButtonText },
	};
};

/**
 * Returns a modal with custom success message.
 * @param {string} language - The language.
 * @param {string} textMessage - Message text body.
 * @returns {import('./types').Modal}
 */
export const BuildOkSuccessModal = (language: string, textMessage: string): Modal => {
	return {
		type: ModalType.SUCCESS,
		textMessage,
		okButton: { text: i18n.getResource(language.toLowerCase(), 'translations', 'general.button.ok') },
	};
};

/**
 * Returns a modal with generic error message.
 * @param {string} title - Title text.
 * @param {string} textMessage - Message text body.
 * @param {string} customButtonText - Custom button title.
 * @param {string} customButtonRoute - Route path to custom button.
 * @returns {import('./types').Modal}
 */
export const BuildCustomErrorModal = (
	title: string,
	textMessage: string,
	customButtonText: string,
	customButtonRoute: string
): Modal => {
	return {
		type: ModalType.ERROR,
		title,
		textMessage,
		customButtons: [
			{
				text: customButtonText,
				type: ModalButtonType.PRIMARY,
				routeTo: customButtonRoute,
			},
		],
	};
};

/**
 * Returns a modal with custom subtitle service error message and custom buttons.
 * @param {string} language - The language.
 * @returns {import('./types').Modal}
 */
export const BuildSubtitleCustomButtonsErrorModal = (
	titleMessage: string,
	textMessage: string,
	customButtons: ModalButton[]
): Modal => {
	return {
		type: ModalType.ERROR,
		title: titleMessage,
		textMessage,
		customButtons: customButtons,
	};
};

/*****
 * Service Errors Modals
 *
 *****/

/**
 * Returns a modal with generic error message.
 * @returns {import('./types').Modal}
 */
export const BuildGenericErrorModal = (language: string): Modal => {
	return {
		type: ModalType.ERROR,
		textMessage: i18n.getResource(language.toLowerCase(), 'translations', 'modals.genericError.textMessage'),
		customButtons: [
			{
				text: i18n.getResource(language.toLowerCase(), 'translations', 'general.button.ok'),
				type: ModalButtonType.PRIMARY,
				// onClick: NativeNavigationHelper.goToAccounts,
			},
		],
	};
};

/**
 * Returns a modal with custom error message and OK button.
 * @returns {import('./types').Modal}
 */
export const BuildCustomMessageGenericErrorModal = (language: string, textMessage: string): Modal => {
	return {
		type: ModalType.ERROR,
		textMessage: textMessage,
		customButtons: [
			{
				text: i18n.getResource(language.toLowerCase(), 'translations', 'general.button.ok'),
				type: ModalButtonType.PRIMARY,
				// onClick: NativeNavigationHelper.goToAccounts,
			},
		],
	};
};

/**
 * Returns a modal with generic operation execution error message.
 * @returns {import('./types').Modal}
 */
export const BuildOperationExecutionErrorModal = (language: string): Modal => {
	return {
		type: ModalType.ERROR,
		textMessage: i18n.getResource(
			language.toLowerCase(),
			'translations',
			'modals.operationExecutionError.textMessage'
		),
		okButton: { text: i18n.getResource(language.toLowerCase(), 'translations', 'general.button.ok') },
	};
};

/**
 * Returns a modal with custom subtitle service error message and custom buttons.
 * @param {string} language - The language.
 * @returns {import('./types').Modal}
 */
export const BuildSubtitleCustomButtonsWarningModal = (
	titleMessage: string,
	textMessage: string,
	customButtons: ModalButton[]
): Modal => {
	return {
		type: ModalType.WARNING,
		title: titleMessage,
		textMessage,
		customButtons: customButtons,
	};
};

/**
 * Returns a modal with custom subtitle service error message and custom buttons.
 * @param {string} language - The language.
 * @returns {import('./types').Modal}
 */
export const BuildSubtitleCustomButtonsWithTableModal = (
	titleMessage: string,
	textMessage: string,
	customButtons: ModalButton[],
	table: React.ReactNode
): Modal => {
	return {
		type: ModalType.INFO,
		title: titleMessage,
		textMessage,
		children: table,
		customButtons: customButtons,
	};
};
